import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {SubgoalModel} from './Subgoal.model';

@injectable()
export class SubgoalFactory
  implements BaseDomainFactory<SubgoalModel, SubgoalModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: SubgoalModel.Props): SubgoalModel {
    return this.modelsRegistry.put(new SubgoalModel(props));
  }
}
